/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default angular.module('agrolog.api.site', [])
    .factory('siteService', SiteService)
    .name;

/*@ngInject*/
function SiteService($q, types, agTypes, entityService, assetService, agUserService, siloService, alarmService, attributeService) {

    var siteAttributesKeys = [agTypes.attributes.site.enable3D];

    var positionAttributeKeys = [];
    positionAttributeKeys.push(agTypes.attributes.baseAsset.positionX);
    positionAttributeKeys.push(agTypes.attributes.baseAsset.positionY);
    positionAttributeKeys.push(agTypes.attributes.baseAsset.latitude);
    positionAttributeKeys.push(agTypes.attributes.baseAsset.longitude);
    positionAttributeKeys.push(agTypes.attributes.site.enable3D);

    var allSystemAttributesKeys = [];

    var allSiteAttributesKeys = [];

    var allSiteAssetAttributesKeys = [];

    for (attrId in agTypes.attributes.system) {
        attr = agTypes.attributes.system[attrId];
        allSystemAttributesKeys.push(attr);
    }

    for (var attrId in agTypes.attributes.baseAsset) {
        var attr = agTypes.attributes.baseAsset[attrId];
        allSiteAttributesKeys.push(attr);
        allSiteAssetAttributesKeys.push(attr);
    }
    for (attrId in agTypes.attributes.site) {
        attr = agTypes.attributes.site[attrId];
        allSiteAttributesKeys.push(attr);
    }
    for (attrId in agTypes.attributes.silo) {
        attr = agTypes.attributes.silo[attrId];
        allSiteAssetAttributesKeys.push(attr);
    }
    for (attrId in agTypes.attributes.siloGroup) {
        attr = agTypes.attributes.siloGroup[attrId];
        allSiteAssetAttributesKeys.push(attr);
    }


    var service = {
        getSystem: getSystem,
        saveSystem: saveSystem,
        getCustomerSites: getCustomerSites,
        saveSite: saveSite,
        getSite: getSite,
        getParentSite: getParentSite,
        getSiteAssets: getSiteAssets,
        getSiteSilos: getSiteSilos,
        fetchSiteAssetAlarmSeverity: fetchSiteAssetAlarmSeverity,
        getSiteMapAssets: getSiteMapAssets,
        getSystemMapSites: getSystemMapSites,
        saveAssetPosition: saveAssetPosition,
        deleteSite: deleteSite
    }

    return service;

    function getSystem(fetchAlarmsSeverity) {
        var deferred = $q.defer();
        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var systemId = agCustomer.id;
                entityService.getRelatedEntity(systemId, allSystemAttributesKeys).then(
                    (system) => {
                        if (fetchAlarmsSeverity) {
                            fetchSiteAssetAlarmSeverity(system).then(
                                (system) => {
                                    deferred.resolve(system);
                                },
                                () => {
                                    deferred.reject();
                                }
                            );
                        } else {
                            deferred.resolve(system);
                        }
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
   }

   function saveSystem(system) {
       var deferred = $q.defer();
       entityService.saveRelatedEntity(system, null, allSystemAttributesKeys).then(
           function success(system) {
               deferred.resolve(system);
           },
           function fail() {
               deferred.reject();
           }
       );
       return deferred.promise;
   }

    function getCustomerSites(fetchAlarmsSeverity) {
        var deferred = $q.defer();
        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var rootEntityId = agCustomer.id;
                entityService.getRelatedEntities(rootEntityId,
                    types.entityType.asset, [agTypes.assetType.site], 1, siteAttributesKeys, agTypes.assetTypeTranslatePrefix).then(
                    function success(sites) {
                        if (fetchAlarmsSeverity) {
                            var alarmsSeverityTasks = [];
                            for (var i=0;i<sites.length;i++) {
                                var site = sites[i];
                                alarmsSeverityTasks.push(fetchSiteAssetAlarmSeverity(site));
                            }
                            $q.all(alarmsSeverityTasks).then(
                                function success(sites) {
                                    deferred.resolve(sites);
                                },
                                function fail() {
                                    deferred.reject();
                                }
                            );
                        } else {
                            deferred.resolve(sites);
                        }
                    },
                    function fail() {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveSite(site) {
        var deferred = $q.defer();
        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var parentEntityId = agCustomer.id;
                var assign = !site.id.id;
                entityService.saveRelatedEntity(site, parentEntityId, allSiteAttributesKeys).then(
                    function success(site) {
                        if (assign) {
                            agUserService.assignAssetToCustomer(site).then(
                                () => {
                                    deferred.resolve(site);
                                },
                                () => {
                                    deferred.reject();
                                }
                            );
                        } else {
                            deferred.resolve(site);
                        }
                    },
                    function fail() {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function getSite(siteId, fetchAlarmsSeverity) {
        var deferred = $q.defer();
        entityService.getRelatedEntity(siteId, allSiteAttributesKeys, agTypes.assetTypeTranslatePrefix).then(
            function success(site) {
                if (fetchAlarmsSeverity) {
                    fetchSiteAssetAlarmSeverity(site).then(
                        (site) => {
                            deferred.resolve(site);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(site);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getParentSite(assetId) {
        var deferred = $q.defer();
        var searchQuery = {
            parameters: {
                rootId: assetId.id,
                rootType: assetId.entityType,
                direction: types.entitySearchDirection.to,
                maxLevel: 1
            },
            relationType: types.entityRelationType.contains,
            assetTypes: [agTypes.assetType.site, agTypes.assetType.siloGroup]
        };
        assetService.findByQuery(searchQuery, true, {ignoreLoading: true}).then(
            (sites) => {
                if (sites && sites.length) {
                    deferred.resolve(sites[0]);
                } else {
                    deferred.reject();
                }
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiteAssets(siteId, fetchAlarmsSeverity, assetWidgetType, providedAssetTypes = []) {
        let assetTypes = providedAssetTypes.length > 0 ? providedAssetTypes : [agTypes.assetType.silo,
            agTypes.assetType.siloGroup,
            agTypes.assetType.weatherStation,
            agTypes.assetType.aeration];

        let assetsAttributes = [agTypes.attributes.aeration.aerationType];
        if (assetWidgetType === agTypes.assetBrowserWidgetType.list) {
            assetsAttributes = assetsAttributes.concat([agTypes.attributes.silo.hasMoistureCables, agTypes.attributes.silo.hasCO2Cables]);
        }
        if (assetWidgetType === agTypes.assetBrowserWidgetType.dashboard) {
            assetsAttributes = assetsAttributes.concat([agTypes.attributes.silo.hasMoistureCables, agTypes.attributes.silo.hasCO2Cables, agTypes.attributes.silo.hasLevelIndicator, agTypes.attributes.silo.hasHeadSpaceSensor]);
        }
        return fetchSiteAssets(siteId, assetsAttributes, fetchAlarmsSeverity, assetTypes);
    }

    function getSiteSilos(siteId, fetchAlarmsSeverity) {
      let assetTypes = [agTypes.assetType.silo];
      return fetchSiteAssets(siteId, [], fetchAlarmsSeverity, assetTypes, 0);
    }

    function getSystemMapSites(fetchAlarmsSeverity) {
        var deferred = $q.defer();
        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var rootEntityId = agCustomer.id;
                fetchSiteAssets(rootEntityId, positionAttributeKeys, fetchAlarmsSeverity, [agTypes.assetType.site]).then(
                    (siteAssets) => {
                        deferred.resolve(siteAssets);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSiteMapAssets(siteId, fetchAlarmsSeverity) {
        var assetTypes = [agTypes.assetType.silo,
            agTypes.assetType.siloGroup,
            agTypes.assetType.weatherStation];
        return fetchSiteAssets(siteId, positionAttributeKeys, fetchAlarmsSeverity, assetTypes);
    }

    function saveAssetPosition(asset, attributeKeys = []) {
        var deferred = $q.defer();
        var attributes = [];

        let keys = positionAttributeKeys;
        if (attributeKeys?.length > 0) {
          keys = attributeKeys;
        }

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            attributes.push({key: key, value: asset[key]});
        }

        attributeService.saveEntityAttributes(asset.id.entityType, asset.id.id, types.attributesScope.server.value, attributes)
            .then(
                function success() {
                    deferred.resolve(asset);
                },
                function fail() {
                    deferred.reject();
                }
        );
        return deferred.promise;
    }

    function fetchSiteAssets(siteId, keys, fetchAlarmsSeverity, assetTypes, maxLevel) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(siteId, types.entityType.asset,
            assetTypes, maxLevel,
            keys, agTypes.assetTypeTranslatePrefix).then(
            function success(siteAssets) {
                if (fetchAlarmsSeverity) {
                    var alarmsSeverityTasks = [];
                    for (let i = 0; i < siteAssets.length; i++) {
                        var siteAsset = siteAssets[i];
                        alarmsSeverityTasks.push(fetchSiteAssetAlarmSeverity(siteAsset));
                    }
                    $q.all(alarmsSeverityTasks).then(
                        function success(siteAssets) {
                            var connectedSystemsTasks = [];
                            for (let i = 0; i < siteAssets.length; i++) {
                                if (siteAssets[i].type === agTypes.assetType.silo) {
                                    connectedSystemsTasks.push(siloService.getSiloConnectedSystems(siteAssets[i].id, fetchAlarmsSeverity));
                                } else {
                                    connectedSystemsTasks.push($q.when([]));
                                }
                            }
                            $q.all(connectedSystemsTasks).then(
                                function success(connectedSystemsData) {
                                    for (let i = 0; i < siteAssets.length; i++) {
                                        siteAssets[i].connectedSystems = (connectedSystemsData[i] && connectedSystemsData[i].length) ? connectedSystemsData[i] : null;
                                    }
                                    deferred.resolve(siteAssets);
                                },
                                function fail() {
                                    deferred.reject();
                                }
                            )
                        },
                        function fail() {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(siteAssets);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function fetchSiteAssetAlarmSeverity(siteAsset) {
        var deferred = $q.defer();
        alarmService.getHighestActiveAlarmInfo(siteAsset.id.entityType, siteAsset.id.id).then(
            function success(highestAlarm) {
              if (highestAlarm) {
                siteAsset.highestAlarmSeverity = highestAlarm.severity;
                siteAsset.highestAlarmStatus = highestAlarm.status;
              }

              deferred.resolve(siteAsset);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteSite(siteId) {
        var deferred = $q.defer();
        entityService.deleteRelatedEntity(siteId, [types.entityType.asset]).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }
}
